import { Injectable } from '@angular/core';
import swal from 'sweetalert2';
import { BehaviorSubject, interval, Subscription, Observable } from 'rxjs';
import * as XLSX from 'xlsx';
import * as FileSaver from 'file-saver';
import { ApiService } from './api.service';

declare const $: any;

export interface TimeoutHandle {
  readonly timeLeft$: Observable<number>;
  readonly expired: boolean;
  stop(): void;
}

@Injectable({
  providedIn: 'root'
})
export class UtilityService {

  constructor(private apiService: ApiService) { }

  copyMessage(val: string) {
    var text = JSON.stringify(val);
    navigator.clipboard.writeText(text).then().catch(e => console.error(e));
  }

  uuidv4() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
      var r = Math.random() * 16 | 0, v = c == 'x' ? r : (r & 0x3 | 0x8);
      return v.toString(16);
    });
  }

  isNumber = function isNumber(value) {
    if (isFinite(value)) {
      return true;
    }
    return false;
  }

  GetDateUTC(value) {
    const date = new Date(value);
    // Date in UTC time zone
    return date.toUTCString();
    // Sun, 20 Jun 2021 11:36:56 GMT
  }

  isObject(val) {
    if (val === null) { return false; }
    return ((typeof val === 'function') || (typeof val === 'object'));
  }

  showNotification(from: any, align: any, title: string, textMessage: string, alertType: string, timer: number) {
    const type = ['', 'info', 'success', 'warning', 'danger', 'rose', 'primary'];
    const alertTypeObj = [
      { "alert": "primary", "icon": "bx bx-bookmark-heart", "text-color": "text-white" },
      { "alert": "secondary", "icon": "bx bx-tag-alt", "text-color": "text-white" },
      { "alert": "success", "icon": "bx bxs-check-circle", "text-color": "text-white" },
      { "alert": "danger", "icon": "bx bxs-message-square-x", "text-color": "text-white" },
      { "alert": "warning", "icon": "bx bx-info-circle", "text-color": "text-dark" },
      { "alert": "info", "icon": "bx bx-info-square", "text-color": "text-dark" },
      { "alert": "dark", "icon": "bx bx-bell", "text-color": "text-white" },
    ]

    var selectedAlert = alertTypeObj.find(r => r.alert == alertType);
    if (selectedAlert == undefined || selectedAlert == null) {
      selectedAlert = alertTypeObj[5];
    }

    if (alertType == 'dark' || alertType == 'secondary')
      alertType = "info";

    $.notify({
      icon: 'notifications',
      message: textMessage
    }, {
      type: type[alertType],
      timer: timer,
      placement: {
        from: from,
        align: align
      },

      template: '<div class="alert alert-' + selectedAlert.alert + ' border-0 bg-' + selectedAlert.alert + ' alert-dismissible fade show py-2">' +
        '<div class="d-flex align-items-center">' +
        '  <div class="font-35 ' + selectedAlert['text-color'] + '"><i class="' + selectedAlert.icon + '"></i>' +
        '  </div>' +
        '  <div class="ms-3">' +
        '    <h6 class="mb-0 ' + selectedAlert['text-color'] + '">' + title + '</h6>' +
        '    <div class="' + selectedAlert['text-color'] + '">' + textMessage + '</div>' +
        '  </div>' +
        '</div>' +
        '<button type="button" class="btn-close" data-bs-dismiss="alert" aria-label="Close"></button>' +
        '</div>',
    });

  }

  addDays(date, days) {
    var result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  GetOnlyDate(todayStr, formatDate) {
    //recibe una fecha
    var today: any = new Date(todayStr);
    //today == 
    var dd: any = today.getDate();
    var mm: any = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    if (formatDate == 'mmddyyyy')
      today = mm + '/' + dd + '/' + yyyy;
    else if (formatDate == 'ddmmyyyy')
      today = dd + '/' + mm + '/' + yyyy;
    else if (formatDate == 'yyyymmdd')
      today = yyyy + '/' + mm + '/' + dd;

    return today;
  }

  decodeHtml(html) {
    var txt = document.createElement("textarea");
    txt.innerHTML = html;
    return txt.value;
  }

  ReturnDate = function (RangeName: string): Date {
    //RangeName: 
    //CurrentMonthStart - CurrentMonthEnd
    //LastMonthStart - LastMonthEnd
    //Last2MonthStart - Last2MonthEnd
    //CurrentYearStart

    if (RangeName == "CurrentMonthStart") {
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      return firstDay;
    }
    if (RangeName == "CurrentMonthEnd") {
      var date = new Date();
      return date;
    }
    if (RangeName == "LastMonthStart") {
      var yourDate = new Date();
      return new Date(yourDate.getFullYear(), yourDate.getMonth() - 1, 1);
    }
    if (RangeName == "LastMonthEnd") {
      var yourDate = new Date();
      var ndate = new Date(yourDate.getFullYear(), yourDate.getMonth() - 1, 1);
      var firstDay = new Date(ndate.getFullYear(), ndate.getMonth(), 1);
      var lastDay = new Date(ndate.getFullYear(), ndate.getMonth() + 1, 0);
      return lastDay;
    }
    if (RangeName == "Last2MonthStart") {
      var yourDate = new Date();
      var ndate = new Date(yourDate.getFullYear(), yourDate.getMonth() - 2, 1);
      var firstDay = new Date(ndate.getFullYear(), ndate.getMonth(), 1);
      var lastDay = new Date(ndate.getFullYear(), ndate.getMonth() + 1, 0);
      return firstDay;
    }
    if (RangeName == "Last2MonthEnd") {
      var yourDate = new Date();
      var ndate = new Date(yourDate.getFullYear(), yourDate.getMonth() - 2, 1);
      var firstDay = new Date(ndate.getFullYear(), ndate.getMonth(), 1);
      var lastDay = new Date(ndate.getFullYear(), ndate.getMonth() + 1, 0);
      return lastDay;
    }
    // **** 2025-01-13 JFRH: New date ranges defined
    if (RangeName == "CurrentYearStart") {
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), 0, 1);
      return firstDay;
    }
    if (RangeName == "Last6MonthStart") {
      var yourDate = new Date();
      var ndate = new Date(yourDate.getFullYear(), yourDate.getMonth() - 6, 1);
      var firstDay = new Date(ndate.getFullYear(), ndate.getMonth(), 1);
      // var lastDay = new Date(ndate.getFullYear(), ndate.getMonth() + 1, 0);
      return firstDay;
    }
    if (RangeName == "LastYearStart") {
      var date = new Date();
      var firstDay = new Date(date.getFullYear() - 1, 0, 1);
      return firstDay;
    }
    if (RangeName == "LastYearEnd") {
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), 0, 1);
      var lastDay = new Date(firstDay.setDate(firstDay.getDate() - 1));
      return lastDay;
    }
  };

  ReturnDateByRangeID = function (RangeID: number): any {
    if (RangeID == 1) {
      var d = new Date();
      d.setDate(d.getDate() - 1);
      return d;
    }
    if (RangeID == 21) {
      d = new Date();
      var day = d.getDay(),
        diff = d.getDate() - day + (day == 0 ? -6 : 1);
      return new Date(d.setDate(diff));
    }
    if (RangeID == 31) {
      var date = new Date();
      var firstDay = new Date(date.getFullYear(), date.getMonth(), 1);
      return firstDay;
    }
    if (RangeID == 41) {
      var yourDate = new Date();
      return new Date(yourDate.getFullYear(), yourDate.getMonth() - 1, 1);
    }
    if (RangeID == 42) {
      var yourDate = new Date();
      var ndate = new Date(yourDate.getFullYear(), yourDate.getMonth() - 1, 1);
      var firstDay = new Date(ndate.getFullYear(), ndate.getMonth(), 1);
      var lastDay = new Date(ndate.getFullYear(), ndate.getMonth() + 1, 0);
      return lastDay;
    }

    if (RangeID == 50) {
      var yourDate = new Date();
      //return new Date(yourDate.getFullYear(), yourDate.getMonth() - 1, 1);
      var ndate = new Date(yourDate.getFullYear(), yourDate.getMonth() + 1, 1);
      return ndate;

    }

    if (RangeID == 51) {
      var yourDate = new Date();
      //return new Date(yourDate.getFullYear(), yourDate.getMonth() - 1, 1);
      var ndate = new Date(yourDate.getFullYear(), yourDate.getMonth() + 1, 1);
      var firstDay = new Date(ndate.getFullYear(), ndate.getMonth(), 1);
      var lastDay = new Date(firstDay.getFullYear(), ndate.getMonth() + 1, 0);
      return lastDay;

    }
  };

  initDateRange() {

    return [
      {
        "RangeID": 0,
        "Text": 'Today',
        "StartDate": new Date(),
        "EndDate": new Date()
      }, {
        "RangeID": 1,
        "Text": 'Yesterday',
        "StartDate": this.ReturnDateByRangeID(1),
        "EndDate": this.ReturnDateByRangeID(1)
      }, {
        "RangeID": 2,
        "Text": 'Week to date',
        "StartDate": this.ReturnDateByRangeID(21),
        "EndDate": new Date()
      }, {
        "RangeID": 3,
        "Text": 'Month to date',
        "StartDate": this.ReturnDateByRangeID(31),
        "EndDate": new Date()
      }, {
        "RangeID": 4,
        "Text": 'Previous Month',
        "StartDate": this.ReturnDateByRangeID(41),
        "EndDate": this.ReturnDateByRangeID(42)
      }, {
        "RangeID": 5,
        "Text": 'Custom',
        "StartDate": new Date(),
        "EndDate": new Date()
      }
    ];

  }

  //Función original
  // sortBy(arrayList: any, columnName: string, orderSort: string) {

  //   var prop = columnName;
  //   if (prop != "") {
  //     if (orderSort  == 'Ascending' || orderSort  == "ASC")
  //       return arrayList.sort((a, b) => a[prop] > b[prop] ? 1 : a[prop] === b[prop] ? 0 : -1);
  //     if (orderSort == 'Descending' || orderSort  == "DESC")
  //       return arrayList.sort((a, b) => a[prop] > b[prop] ? -1 : a[prop] === b[prop] ? 0 : 1);
  //   }
  //   else{
  //     return arrayList;
  //   }
  //   return arrayList;
  // }




  /**
 * Función para ordenar un array de objetos por una columna específica.
 * La función es capaz de manejar la comparación de valores numéricos, fechas y texto.
 *
 * @param {any[]} arrayList - El array de objetos que se va a ordenar.
 * @param {string} columnName - El nombre de la columna por la que se ordenará el array.
 * @param {string} orderSort - El tipo de ordenamiento ('Ascending', 'ASC', 'Descending', 'DESC').
 * @returns {any[]} El array ordenado según los criterios proporcionados.
 */
  sortBy(arrayList: any[], columnName: string, orderSort: string): any[] {
    var prop = columnName;

    // Validar que el nombre de la columna no esté vacío
    if (prop != "") {
      return arrayList.sort((a, b) => {
        const valueA = a[prop];
        const valueB = b[prop];

        // Verificar si los valores son números
        if (!isNaN(valueA) && !isNaN(valueB)) {
          return this.compareNumbers(valueA, valueB, orderSort);
        }

        // Verificar si los valores son fechas
        if (this.isValidDate(valueA) && this.isValidDate(valueB)) {
          return this.compareDates(valueA, valueB, orderSort);
        }

        // Asumir que los valores son texto y compararlos en mayúsculas
        return this.compareText(valueA, valueB, orderSort);
      });
    } else {
      // Si no se especifica una columna, devolver la lista sin cambios
      return arrayList;
    }
  }

  /**
  * Función para comparar dos valores numéricos y ordenarlos.
  *
  * @param {number} a - El primer número a comparar.
  * @param {number} b - El segundo número a comparar.
  * @param {string} orderSort - El tipo de ordenamiento ('Ascending', 'ASC', 'Descending', 'DESC').
  * @returns {number} El resultado de la comparación (-1, 0, 1) para ordenar los números.
  */
  compareNumbers(a: number, b: number, orderSort: string): number {
    return orderSort === 'Ascending' || orderSort === 'ASC' ? a - b : b - a;
  }

  /**
  * Función para comparar dos valores de fecha y ordenarlos.
  *
  * @param {any} a - El primer valor de fecha a comparar.
  * @param {any} b - El segundo valor de fecha a comparar.
  * @param {string} orderSort - El tipo de ordenamiento ('Ascending', 'ASC', 'Descending', 'DESC').
  * @returns {number} El resultado de la comparación (-1, 0, 1) para ordenar las fechas.
  */
  compareDates(a: any, b: any, orderSort: string): number {
    const dateA = new Date(a).getTime(); // Convertir la fecha en milisegundos
    const dateB = new Date(b).getTime(); // Convertir la fecha en milisegundos
    return orderSort === 'Ascending' || orderSort === 'ASC' ? dateA - dateB : dateB - dateA;
  }

  /**
  * Función para comparar dos valores de texto y ordenarlos ignorando mayúsculas.
  *
  * @param {string} a - El primer valor de texto a comparar.
  * @param {string} b - El segundo valor de texto a comparar.
  * @param {string} orderSort - El tipo de ordenamiento ('Ascending', 'ASC', 'Descending', 'DESC').
  * @returns {number} El resultado de la comparación (-1, 0, 1) para ordenar los textos.
  */
  compareText(a: string, b: string, orderSort: string): number {
    const upperA = a.toUpperCase(); // Convertir a mayúsculas
    const upperB = b.toUpperCase(); // Convertir a mayúsculas

    if (upperA > upperB) return orderSort === 'Ascending' || orderSort === 'ASC' ? 1 : -1;
    if (upperA < upperB) return orderSort === 'Ascending' || orderSort === 'ASC' ? -1 : 1;
    return 0; // Si son iguales
  }




  truncateDecimals = function (number, digits) {
    var multiplier = Math.pow(10, digits),
      adjustedNum = number * multiplier,
      truncatedNum = Math[adjustedNum < 0 ? 'ceil' : 'floor'](adjustedNum);

    return truncatedNum / multiplier;
  };

  columnSum(items, attr) {
    if (items != undefined)
      if (items.length > 0)
        return items.reduce((a, b) => a + b[attr], 0);
      else
        return 0;
  }

  setLogoMetaData(file, width, height, prefix, identity) {

    const formData = new FormData();

    formData.append("SelectedImage", file);
    formData.append("NombreArchivo", file.name);
    formData.append("UrlGeneral", "Images");
    formData.append("PrefijoImagen", prefix);
    formData.append("Entity_DB_ID", identity);
    formData.append("SizeImageWidth", width);
    formData.append("SizeImageHeight", height);

    return formData;

  }

  ReturnYMD = function (today) {
    var dd = today.getDate();
    var mm = today.getMonth() + 1; //January is 0!
    var yyyy = today.getFullYear();

    if (dd < 10) {
      dd = '0' + dd
    }

    if (mm < 10) {
      mm = '0' + mm
    }

    //today = mm + '/' + dd + '/' + yyyy;
    today = yyyy + '/' + mm + '/' + dd;

    return today;

  }



  openModal(name: string): void {
    var ModalName = '#' + name;
    let element = $(ModalName);
    element.modal('show');
  }

  closeModal(name: string): void {
    var ModalName = '#' + name;
    let element = $(ModalName);
    element.modal('hide');
  }

  ListContentValidation(list) {
    if (list != undefined)
      if (list != null)
        if (list.length > 0) {
          return true;
        }
    return false;
  }

  fnValidateEmail(email) {
    const re = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(email);
  }

  validateEmail(email) {
    if (this.fnValidateEmail(email)) {
      return true;
    } else {
      return false;
    }
    return false;
  }

  RoundMax(numero) {
    return Math.ceil(numero);
  }

  pad = function (num, size) {
    var s = "000000000" + num;
    return s.substr(s.length - size);
  }

  s2ab(s) {
    var buf = new ArrayBuffer(s.length); //convert s to arrayBuffer
    var view = new Uint8Array(buf);  //create uint8array as viewer
    for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF; //convert to octet
    return buf;
  }

  clearString(s) {
    s = s.replace(/ +/g, ' ')
    return s;
  }

  Round(n: number, d: number): number {
    var p = Math.pow(10, d);
    return Math.round(n * p) / p;
  }

  DecodeUri(query) {

    var queryEnc = encodeURIComponent(query)
    var queryDec = decodeURIComponent(queryEnc)
    return queryDec;
  }

  ShowError(item, title) {
    swal({
      title: title,
      text: item.err,
      buttonsStyling: false,
      confirmButtonClass: "btn btn-danger"
    }).catch(swal.noop);
    console.log('Error (' + title + ') : ', item.err)
    if (swal.isVisible())
      swal.close();
  }

  OpenModalGeneric(name: string): void {
    var ModalName = '#' + name;
    let element = $(ModalName);
    element.modal('show');
  }

  //generatePasswordRand(6,'alf'); ///modo de uso.
  generatePasswordRand(length, type) {
    var characters = "";
    switch (type) {
      case 'num':
        characters = "0123456789";
        break;
      case 'alf':
        characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ";
        break;
      case 'rand':
        //FOR ↓
        break;
      default:
        characters = "abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789";
        break;
    }
    var pass = "";
    for (var i = 0; i < length; i++) {
      if (type == 'rand') {
        pass += String.fromCharCode((Math.floor((Math.random() * 100)) % 94) + 33);
      } else {
        pass += characters.charAt(Math.floor(Math.random() * characters.length));
      }
    }
    return pass;
  }


  copyText(val: string) {
    var text = val;
    navigator.clipboard.writeText(text).then().catch(e => console.error(e));
  }

  DownloadListArray(header, ListArray, sheetName) {
    var ws_data = [[]];
    for (var i = 0; i < header.length; i++) {
      ws_data[0][i] = header[i].Title;
    }

    ListArray.forEach(function (itemList, idxList) {
      var idxLocal = idxList + 1;
      ws_data[idxLocal] = [];
      header.forEach(function (itemHeader, idxHeader) {
        ws_data[idxLocal][idxHeader] = itemList[itemHeader.Column];
      });
    });

    var wb = XLSX.utils.book_new();

    wb.Props = {
      Title: sheetName,
      Subject: sheetName,
      Author: "MyAdOptimizer",
      CreatedDate: new Date()
    };
    wb.SheetNames.push(sheetName);
    var ws = XLSX.utils.aoa_to_sheet(ws_data);
    wb.Sheets[sheetName] = ws;
    var wbout = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });
    FileSaver.saveAs(new Blob([this.s2ab(wbout)], { type: "application/octet-stream" }), sheetName + "_" + this.apiService.uuidv4() + ".xlsx");

  }

  async SaveAdminLogFieldChange(moduleName: string, subModuleName: string, itemID: number, addedBy: string, userID: number, logEventTypeID: number, fieldName: string, oldValue: string, newValue: string, comments: string, moduleUIID: number = 1) {

    var adminUILog = {
      "AdminUILogID": 0,
      "ModuleName": moduleName,
      "SubModuleName": subModuleName,
      "ItemID": itemID,
      "AddedBy": addedBy,
      "UserID": userID,
      "UserIP": null,
      "DateAdded": null,
      "LogEventTypeID": logEventTypeID,
      "FieldName": fieldName,
      "OldValue": oldValue,
      "NewValue": newValue,
      "Comments": comments,
      "ModuleUIID": moduleUIID,
      "VerticalID": null,
      "PublisherID": null
    };

    await this.apiService.saveAdminLog(adminUILog).subscribe(post => {
      var postResult: any;
      postResult = post;
      if (postResult.code == 0) {
        return;
      }
      else {
        console.log("Error <SaveAdminLogFieldChange>: " + postResult.technicalDescription);
      }
    });
  };


  addOrderPropertyToArrayObject(headers: any[]): any[] {
    return headers.map((header, index) => {
      return { ...header, Order: index + 1 };
    });
  }



  addOrderPropertyToHeaders(headers: any[]): any[] {
    //const isMobile = window.innerWidth <= 768;
    const isMobile = window.innerWidth <= 1000;

    if (isMobile) {
      const priorityColumns = ['Clicks', 'CTR', 'CPC', 'MAOProfit']; // Columnas prioritarias (sin "ResultCol")
      const titleColumn = 'ResultCol';

      // Asignamos las categorías directamente aquí (primero "title", luego "priority")
      const headersWithCategory = headers.map(header => ({
        ...header,
        Category: header.Column === titleColumn ? 'title' : (priorityColumns.includes(header.Column) ? 'priority' : 'normal')
      }));

      // Obtenemos el encabezado del título
      const titleHeader = headersWithCategory.find(h => h.Category === 'title');

      // Ordenamos las columnas prioritarias según el orden deseado
      const priorityHeaders = priorityColumns.map(column => {
        return headersWithCategory.find(h => h.Column === column);
      });

      // Obtenemos las columnas restantes
      const remainingColumns = headersWithCategory.filter(h => h.Category === 'normal');

      // Creamos el arreglo final con el orden deseado
      const orderedHeaders = [];

      // agregamos primero el titulo
      if (titleHeader) {
        orderedHeaders.push(titleHeader);
      }
      // Agregamos las columnas prioritarias con nuevo orden
      orderedHeaders.push(...priorityHeaders.map((header, index) => ({ ...header, Order: index + 2 })));

      // Agregamos las columnas restantes en su orden original (sin modificar el Order)
      orderedHeaders.push(...remainingColumns);

      //return orderedHeaders; // Sin reasignar Order a las columnas normales
      var resultTemp = orderedHeaders.map((header, index) => ({ ...header, Order: index + 1 }));
      //console.log(JSON.stringify(resultTemp));
      return resultTemp;


    } else {
      // En desktop, mantener el orden original (sin cambios)
      return headers.map((header, index) => ({ ...header, Order: index + 1 }));
    }
  }

  addOrderPropertyToHeadersAdvertiser(headers: any[]): any[] {
    //const isMobile = window.innerWidth <= 768;
    const isMobile = window.innerWidth <= 1000;

    if (isMobile) {
      const priorityColumns = ['Clicks', 'CTR', 'AdvertiserCPC', 'MAORevenue']; // Columnas prioritarias (sin "ResultCol")
      const titleColumn = 'ResultCol';

      // Asignamos las categorías directamente aquí (primero "title", luego "priority")
      const headersWithCategory = headers.map(header => ({
        ...header,
        Category: header.Column === titleColumn ? 'title' : (priorityColumns.includes(header.Column) ? 'priority' : 'normal')
      }));

      // Obtenemos el encabezado del título
      const titleHeader = headersWithCategory.find(h => h.Category === 'title');

      // Ordenamos las columnas prioritarias según el orden deseado
      const priorityHeaders = priorityColumns.map(column => {
        return headersWithCategory.find(h => h.Column === column);
      });

      // Obtenemos las columnas restantes
      const remainingColumns = headersWithCategory.filter(h => h.Category === 'normal');

      // Creamos el arreglo final con el orden deseado
      const orderedHeaders = [];

      // agregamos primero el titulo
      if (titleHeader) {
        orderedHeaders.push(titleHeader);
      }
      // Agregamos las columnas prioritarias con nuevo orden
      orderedHeaders.push(...priorityHeaders.map((header, index) => ({ ...header, Order: index + 2 })));

      // Agregamos las columnas restantes en su orden original (sin modificar el Order)
      orderedHeaders.push(...remainingColumns);

      //return orderedHeaders; // Sin reasignar Order a las columnas normales
      var resultTemp = orderedHeaders.map((header, index) => ({ ...header, Order: index + 1 }));
      //console.log(JSON.stringify(resultTemp));
      return resultTemp;


    } else {
      // En desktop, mantener el orden original (sin cambios)
      return headers.map((header, index) => ({ ...header, Order: index + 1 }));
    }
  }


  // sorting-utils.ts

  /**
   * Función para comparar valores, manejando mayúsculas/minúsculas, números y fechas.
   * @param a El primer valor a comparar.
   * @param b El segundo valor a comparar.
   * @param order Orden de la comparación: 'asc' para ascendente, 'desc' para descendente.
   * @returns Un número negativo si a < b, positivo si a > b, o 0 si son iguales.
   */
  compareValues(a: any, b: any, order: string): number {
    // Si ambos valores son fechas válidas, hacer una comparación de fechas
    if (this.isValidDate(a) && this.isValidDate(b)) {
      const dateA = new Date(a).getTime();  // Convertir a milisegundos
      const dateB = new Date(b).getTime();  // Convertir a milisegundos
      return order === 'asc' ? dateA - dateB : dateB - dateA;
    }

    // Si los valores son números, compararlos directamente
    if (!isNaN(a) && !isNaN(b)) {
      return order === 'asc' ? a - b : b - a;
    }

    // Si es texto (string), compararlo en mayúsculas (ignorar diferencias de capitalización)
    if (typeof a === 'string' && typeof b === 'string') {
      const upperA = a.toUpperCase();
      const upperB = b.toUpperCase();
      if (upperA > upperB) return order === 'asc' ? 1 : -1;
      if (upperA < upperB) return order === 'asc' ? -1 : 1;
      return 0; // Si son iguales
    }

    // De lo contrario, dejar el orden original
    return 0;
  }

  /**
  * Función para validar si un string es una fecha válida.
  * @param dateString El valor a validar como fecha.
  * @returns Verdadero si el string es una fecha válida, falso en caso contrario.
  */
  isValidDate(dateString: any): boolean {
    const date = Date.parse(dateString);
    return !isNaN(date);
  }

  startTimeOutCountdown(seconds: number): TimeoutHandle {
    const timeLeft$ = new BehaviorSubject<number>(Math.max(0, seconds | 0));
    let expired = false;
    let sub: Subscription = interval(1000).subscribe(() => {
      const v = timeLeft$.getValue();
      const next = v > 0 ? v - 1 : 0;
      timeLeft$.next(next);

      if (next === 0 && !expired) {
        expired = true;
        // Auto-stop: do not keep emitting 0 indefinitely
        if (sub) { sub.unsubscribe(); sub = null; }
        timeLeft$.complete(); // no more emissions
      }
    });

    return {
      get timeLeft$() { return timeLeft$.asObservable(); },
      get expired() { return expired; },
      stop() {
        if (sub) { sub.unsubscribe(); sub = null; }
        if (!timeLeft$.isStopped) timeLeft$.complete();
      }
    };
  }

  /** Ignora el resultado si el timeout ya expiró. */
  async guardPromise<T>(p: Promise<T>, h: TimeoutHandle): Promise<T | undefined> {
    try {
      const r = await p;
      if (h.expired) return undefined; // llegó tarde
      return r;
    } finally {
      h.stop(); // limpia siempre
    }
  }

}
